import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c9ec47d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0c9ec47d&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=0c9ec47d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ec47d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9ec47d')) {
      api.createRecord('0c9ec47d', component.options)
    } else {
      api.reload('0c9ec47d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c9ec47d&scoped=true", function () {
      api.rerender('0c9ec47d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/globalMods/index.vue"
export default component.exports